app.controller('manualPaymentsController', async function ($rootScope, $scope, $filter, safeApply, accountingService) {

  const manual_payments_table = '#manual-payments-table'
  const manual_payments_modal = 'manual-payments-modal'
  let check_entry_button

  // Pulls in user info from the rootScope -> CRMController
  $rootScope.$watch('user_info', function () {
    $scope.user_info = $rootScope.user_info
  }, true)

  let getGoldClientsResults = await accountingService.getGoldClients()
  if (getGoldClientsResults.data.success) {
    $scope.ledger = getGoldClientsResults.data.data
    if ($.fn.dataTable.isDataTable(manual_payments_table)) {
      $(manual_payments_table).DataTable().destroy()
      $(manual_payments_table).empty()
      table = null
    }
    console.log('$scope.ledger :>> ', $scope.ledger);
    loadDataTable($scope.ledger)
  } else {
    $scope.ledger = []
  }
  safeApply($scope)

  function loadDataTable(records) {
    const columns = [
      { title: "ID", data: 'index', className: 'dt-body-center dt-head-center', searchable: false },
      { className: 'dt-control', orderable: false, data: null, defaultContent: '' },

      { title: "User ID", data: 'user_id', className: 'dt-body-center dt-head-center' },
      { title: "First Name", data: 'first_name', className: 'dt-body-left dt-head-left' },
      { title: "Last Name", data: 'last_name', className: 'dt-body-left dt-head-left' },
      { title: "User Name (Email)", data: 'email', className: 'dt-body-left dt-head-left' },
      { title: "Balance Due", data: 'current_balance_due', className: 'dt-body-right dt-head-right' },
      { title: "EDIT", data: null, className: 'dt-body-center dt-head-center' }
    ]
    let config = {
      data: records,
      scrollY: 'calc(100vh -  380px)',
      scrollX: true,
      pagingType: 'full_numbers',
      dom: 'BQfrtip',
      pageLength: 25,
      deferRender: true,
      lengthMenu: [
        [10, 25, 50, 100, 250, 500],
        ['10 rows', '25 rows', '50 rows', '100 rows', '250 rows', '500 rows']
      ],
      buttons: [
        'pageLength', 'spacer', 'csv', 'excel',
        { extend: 'searchBuilder' }
      ],
      language: {
        searchBuilder: {
          button: 'Filter',
        }
      },
      columns: columns,
      columnDefs: [
        {
          searchPanes: {
            show: true
          }, targets: findTargets(columns, ['type',])
        },
        {
          render: function (data, type, row) {
            return $filter('currency')(data, "$", 2)
          }, targets: findTargets(columns, ['current_balance_due'])
        },
        {
          render: function (data, type, row) {
            return '<button class="btn btn-primary btn-sm check-entry-button" type="button">Enter Payment</button>'
          }, targets: -1
        }
      ],
      "initComplete": function (settings, json) {
        // Event listener for Edit Button
        check_entry_button = $(manual_payments_table + ' tbody').on('click', '.check-entry-button', function (e) {
          e.stopPropagation()
          var data = table.row($(this).parents('tr')).data()
          table.row($(this).parents('tr')).child.hide() // Hide details
          enterCheckPayment(data)
        })
      }
    }
    table = $(manual_payments_table).DataTable(config)
    table.draw()
    safeApply($scope)
  }

  function enterCheckPayment(data) {
    console.log('data :>> ', data);
    $scope.check_payment_modal_data = data
    $scope.check_payment_modal_data.amount = 0
    $scope.check_payment_modal_data.check_number = ''
    var myModal = new bootstrap.Modal(document.getElementById(manual_payments_modal))
    myModal.show()
    safeApply($scope)
    var myModalEl = document.getElementById(manual_payments_modal)
    myModalEl.addEventListener('shown.bs.modal', function (event) {
      document.getElementById('manual-payment-amount').focus()
    })
  }

  $scope.updateManualPayment = async () => {
    console.log('$scope.check_payment_modal_data :>> ', $scope.check_payment_modal_data);
    // Update Object
    let obj = {
      user_id: $scope.check_payment_modal_data.user_id,
      payment_type: 'ck',
      previous_balance: $scope.check_payment_modal_data.current_balance_due,
      balance_due: $scope.check_payment_modal_data.current_balance_due - $scope.check_payment_modal_data.amount,
      amount: $scope.check_payment_modal_data.amount,
      check_cc_id: $scope.check_payment_modal_data.check_number,
      payment_date: moment().format('YYYY-MM-DD'),
      send_email: true,
      email: {
        type: 'manual-payment',
        recipient: $scope.check_payment_modal_data.username,
        bcc_to_archive: true,
        categories: ["Payment"],
        dynamic_template_data: {
          subject: `We received your check and posted it to your account. - [UserID: ${$scope.check_payment_modal_data.user_id} - ${moment().format('MM-DD-YYYY HH:mm')}]`,
          name: $scope.check_payment_modal_data.first_name,
          content: 'test content from client side Controller'
        },
        custom_args: {
          username: $scope.check_payment_modal_data.first_name,
          user_id: $scope.check_payment_modal_data.user_id,
          gold_email_type: 'Check Payment'
        },
      }
    }
    // Update Database
    // console.log('obj :>> ', obj);
    let createPaymentRecordResults = await accountingService.createPaymentRecord(obj)
    console.log('createPaymentRecordResults :>> ', createPaymentRecordResults);

    // Update ledger array
    const balance_due = $scope.check_payment_modal_data.current_balance_due - $scope.check_payment_modal_data.amount
    $scope.ledger[$scope.check_payment_modal_data.index - 1].current_balance_due = balance_due
    $scope.ledger[$scope.check_payment_modal_data.index - 1].ledger.unshift({
      amount: $scope.check_payment_modal_data.amount * -1,
      balance_due: balance_due,
      date_entered: moment().format('YYYY-MM-DD'),
      description: "Payment by Check #" + $scope.check_payment_modal_data.check_number,
      sub_type: "CK Payment",
      type: "credit"
    })
    table.rows().invalidate().draw()  // Forces table to redraw with new data
  }

  // Add event listener for opening and closing details
  // $(manual_payments_table + ' tbody').on('click', 'td.dt-control', function () {
  $(manual_payments_table + ' tbody').on('click', 'td', function () {
    try {
      var tr = $(this).closest('tr')
      var row = table.row(tr)
      if (row.child.isShown()) {
        row.child.hide()
        tr.removeClass('shown')
      } else {
        row.child(format(row.data())).show()
        tr.addClass('shown')
      }
    } catch (error) { }
  })

  function format(d) {
    let html = `<section style="background: #b7feff; padding: 15px 5px 1px 5px; margin: -8px;">
                <h5 class="text-center mb-2">Debits and Credits to Account</h5>
                <table class="table table-sm table-striped" id="manual-payments-table-subtable">
                  <thead>
                    <tr>
                      <th scope="row">Type</th>
                      <th scope="row">From</th>
                      <th class="text-start" scope="row">Date</th>
                      <th class="text-end" scope="row">Amount</th>
                      <th class="text-end" scope="row">Balance Due</th>
                    </tr>
                  </thead>
                  <tbody>`
    d.ledger.forEach(item => {
      html += `<tr class="${item.type}">
                <td>${item.type}</td>
                <td>${item.description}</td>
                <td class="text-start">${$filter('date')(item.date_entered, 'MM-dd-yyyy')}</td>
                <td class="text-end">${$filter('currency')(item.amount, "$", 2)}</td>
                <td class="text-end">${$filter('currency')(item.balance_due, "$", 2)}</td>
              </tr>`
    })
    html += `</tbody></table></section>`
    return html
  }

  // Utility Functions ---------------------------------------------------------
  function findTargets(columns, targets) {
    let result = []
    for (let i = 0; i < columns.length; i++) {
      if (targets.includes(columns[i].data)) result.push(i)
    }
    return result
  }
  // END:  Utility Functions ---------------------------------------------------  

})